!function(factory){"use strict";"function"==typeof define&&define.amd?define(["jquery"],factory):jQuery&&!jQuery.fn.hoverIntent&&factory(jQuery)}(function($){"use strict";var cX,cY,_cfg={interval:100,sensitivity:6,timeout:0},INSTANCE_COUNT=0,track=function(ev){cX=ev.pageX,cY=ev.pageY},compare=function(ev,$el,s,cfg){if(Math.sqrt((s.pX-cX)*(s.pX-cX)+(s.pY-cY)*(s.pY-cY))<cfg.sensitivity)return $el.off(s.event,track),delete s.timeoutId,s.isActive=!0,ev.pageX=cX,ev.pageY=cY,delete s.pX,delete s.pY,cfg.over.apply($el[0],[ev]);s.pX=cX,s.pY=cY,s.timeoutId=setTimeout(function(){compare(ev,$el,s,cfg)},cfg.interval)},delay=function(ev,$el,s,out){return delete $el.data("hoverIntent")[s.id],out.apply($el[0],[ev])};$.fn.hoverIntent=function(handlerIn,handlerOut,selector){var instanceId=INSTANCE_COUNT++,cfg=$.extend({},_cfg);$.isPlainObject(handlerIn)?(cfg=$.extend(cfg,handlerIn),$.isFunction(cfg.out)||(cfg.out=cfg.over)):cfg=$.isFunction(handlerOut)?$.extend(cfg,{over:handlerIn,out:handlerOut,selector:selector}):$.extend(cfg,{over:handlerIn,out:handlerIn,selector:handlerOut});var handleHover=function(e){var ev=$.extend({},e),$el=$(this),hoverIntentData=$el.data("hoverIntent");hoverIntentData||$el.data("hoverIntent",hoverIntentData={});var state=hoverIntentData[instanceId];state||(hoverIntentData[instanceId]=state={id:instanceId}),state.timeoutId&&(state.timeoutId=clearTimeout(state.timeoutId));var mousemove=state.event="mousemove.hoverIntent.hoverIntent"+instanceId;if("mouseenter"===e.type){if(state.isActive)return;state.pX=ev.pageX,state.pY=ev.pageY,$el.off(mousemove,track).on(mousemove,track),state.timeoutId=setTimeout(function(){compare(ev,$el,state,cfg)},cfg.interval)}else{if(!state.isActive)return;$el.off(mousemove,track),state.timeoutId=setTimeout(function(){delay(ev,$el,state,cfg.out)},cfg.timeout)}};return this.on({"mouseenter.hoverIntent":handleHover,"mouseleave.hoverIntent":handleHover},cfg.selector)}});
$(document).ready(function() {
  $("body").on("click", ".close-thank-you", function(){
    $(".swell-post-checkout-sock-smith").remove();
  });

  if(window.location.href.indexOf("/refer") > -1 || window.location.href.indexOf("/rewards") > -1 || window.location.href.indexOf("/account") > -1) {
    $('body').addClass("page-swell-rewards");
  }

  $(document).on("swell:initialized", function() {
    $('.swell-initialized-loader').remove();
    SwellConfig.Redemption.initializeRedemptions(".swell-redemption-option-list-custom");
  });

  $(document).on("swell:setup", function() {
    $('.swell-referral-loader').remove();
    $(".swell-post-checkout-sock-smith").css("display","flex");
    SwellConfig.setupCartRedemptionPopup.initializeRedemtionOptions('.swell-cart-redemption-area');
    SwellConfig.Referral.initializeReferral(".swell-referral");
    Swell.Campaign.initializeCampaigns(".campaign-holder", SwellConfig.Campaign.opts);
    SwellConfig.Campaign.addCreateAccountHover();
    SwellConfig.Campaign.addGoalSpendHover();
    SwellConfig.Tier.initializeDummyTier();
    SwellConfig.Tier.initializeCustomTierProperties();
    SwellConfig.Tier.initializeTiers(".swell-tier-list");
    SwellConfig.Tier.applytierSlickSlider('.swell-tier-list');
    SwellConfig.Tier.setupStatus('.swell-tier-list');
  });

  $(document).on("swell:referral:success", function() {
    SwellConfig.Referral.populateReferrals();
  });

  $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
    let emails = $("#swell-referral-refer-emails").val();
    $(".refer-customer-error").remove();
    if (emails.indexOf(spapi.customer.email) > -1 ) {
      $("<p class=\"refer-customer-error\">Email address is already associated with an account.</p>").insertBefore($("#swell-referral-refer-emails").parent().parent());;
      $("#swell-referral-refer-emails").addClass("error-border");
    }else if(textStatus && textStatus === "Please enter a valid email address"){
      $('<p class=\"refer-customer-error\">Please enter a valid email addresses.</p>').insertBefore($("#swell-referral-refer-emails").parent().parent());
      $("#swell-referral-refer-emails").parent().parent().addClass("error-border");
    } else if(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED"){
      $('<p class=\"refer-customer-error\">Oops, looks like we already know that person. Try another friend\'s email address!</p>').insertBefore($("#swell-referral-refer-emails").parent().parent());
      $("#swell-referral-refer-emails").parent().parent().addClass("error-border");
    }
  });

});

(function() {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: "<li class='swell-campaign' style='background-image: url(<%= campaign.background_image_url %>);'> <div class='swell-campaign-content' data-display-mode='modal' data-campaign-id='<%= campaign.id %>'> <div class='swell-campaign-icon'> <span class='swell-campaign-icon-content'> <i class='<%= campaign.icon %>'> </i> </span> </div> <div class='swell-campaign-type'> <span class='swell-details'><%= campaign.title %></span> </div> <div class='swell-campaign-header'> <span class='swell-header-details'><%= campaign.reward_text %></span> </div> </div> </li>",
        campaignHover: '<div class="swell-campaign-hover"> <div class="swell-campaign-hover-content"> <ul class="swell-link-list"> <li class="swell-link"> <a href="/account/login" class="swell-link-login">Sign In</a> </li> <li class="swell-link"> <a href="/account/register" class="swell-link-register">Sign Up</a> </li> </ul> </div> </div>'
      }
    },
    authenticate: function() {
      if (!spapi.authenticated) {
        spapi.$(document).off("click", ".swell-campaign");
        return $(".swell-campaign").hover(function() {
          return $(this).append(SwellConfig.Campaign.opts.templates.campaignHover);
        }, function() {
          return $(this).find(".swell-campaign-hover").remove();
        });
      }
    },
    addCreateAccountHover: function(){
      if (!spapi.authenticated) {
        $('.swell-campaign .swell-campaign-content[data-campaign-id="535702"]').parent().append('<p class="Q_mark swell_black">?<span class="Q_mark_hover">When creating an account<br>please sign up to our newsletter<br>to get more awards!</span></p>');
      }
    },
    addGoalSpendHover: function(){
      if (!spapi.authenticated) {
        $('.swell-campaign .swell-campaign-content[data-campaign-id="556310"]').parent().append('<p class="Q_mark swell_green">?<span class="Q_mark_hover">Equivalent to a free pair!</span></p>');
      }
    }
  };
}).call(this);

(function() {
   window.SwellConfig = window.SwellConfig || {};

   SwellConfig.Referral = {
      opts_fun:()=>{
        return opts = {
           localization: {
            referralSidebarDetailsAction: "",
            referralSidebarDetailsReward: "",

            referralRegisterHeading: "<span class='refer-heading'><span class='swell-raf-icon-holder'><i class='swell-icon-raf'></i></span>Refer a friend</span><img src='//retail.socksmithcanada.ca/cdn/shop/t/14/assets/swell-give-get.png?v=67032502522031293951728495109'/>",
            referralRegisterDetails: "Give your friend $5 off on their first order<br class='swell-mobile'> of $30+ and get $5 for each<br class='swell-mobile'> successful referral.",
            referralRegisterFormDetails: "Enter your email to get started.",
            referralRegisterFormEmail: "Your email...",
            referralRegisterFormSubmit: "next",

            referralReferHeading: "<span class='refer-heading'><span class='swell-raf-icon-holder'><i class='swell-icon-raf'></i></span>Refer a friend</span><img src='//retail.socksmithcanada.ca/cdn/shop/t/14/assets/swell-give-get.png?v=67032502522031293951728495109'/>",
            referralReferDetails: "Give your friend $5 off on their first order<br class='swell-mobile'> of $30+ and get $5 for each<br class='swell-mobile'> successful referral.",
            referralReferFormSubmit: "send",
            referralReferFormDetails: "Now, enter your friends’ emails.",
            referralReferFormEmailsDetails: "Your friends’ emails (separated by commas)",

            referralShareFacebook: "Share",
            referralShareMessenger: "Message",
            referralShareTwitter: "Tweet",
            referralShareSMS: "SMS",
            referralShareCopy: "Copy Link",

            referralFacebookIcon: "swell-icon-facebook-share",
            referralMessengerIcon: "swell-icon-fb-message",
            referralTwitterIcon: "swell-icon-tweet",
            referralLinkIcon: "swell-icon-copylink",
            referralSMSIcon: "swell-icon-sms",

            referralThanksHeading: "Thanks for Referring!",
            referralThanksDetails: "Remind your friends to check their emails.",

            referralCopyHeading: "",
            referralCopyButton: "Copy link",
            referralCopyDetails: "Copy link and share with your friends."
          },
          templates: {
            referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <p class="swell-referral-details"> <%= localization.referralReferDetails %> </p> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"> <%= localization.referralReferFormDetails %> </p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmailsDetails %>"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </li> </ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i> <%= localization.referralShareFacebook %> </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralSMSIcon %>" aria-hidden="true"></i> <%= localization.referralShareSMS %> </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralMessengerIcon %>" aria-hidden="true"></i> <%= localization.referralShareMessenger %> </div> </li> <li class="swell-referral-medium swell-share-referral-twitter"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralTwitterIcon %>" aria-hidden="true"></i> <%= localization.referralShareTwitter %> </div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i> <%= localization.referralShareCopy %> </div> </li> </ul> </div> </div>',
            referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <p class="swell-referral-details"><%= localization.referralRegisterDetails %></p> <div class="swell-referral-form-wrapper"> <form name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralRegisterFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"> </li> </ul> </div> </form> </div> </div>'
          }
        }
      },
      initializeReferral: function(containerSelector) {
        var email = $(containerSelector).data("customer-email");
        if (email) {
          spapi.storage.setItem("referrer_email", email);
          spapi.customer.email = email;
        }
        Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts_fun());
        SwellConfig.Referral.populateReferrals();

        $('body').on('click','.referral-button-content .swell-referral-refer-show-link',(e)=>{
          if(e.currentTarget.className.indexOf('swell-active') < 0){
            $('.referral-button-content .swell-referral-refer-show-link').addClass('swell-active');
            $('.swell-referral-holder .swell-referral').addClass('swell-active');
            $('.referral-button-content .swell-referral-referrals-show-link').removeClass('swell-active');
            $('.swell-referral-holder .referral-content').removeClass('swell-active');
          }
        });
        $('body').on('click','.referral-button-content .swell-referral-referrals-show-link',(e)=>{
          if(e.currentTarget.className.indexOf('swell-active') < 0){
            $('.referral-button-content .swell-referral-referrals-show-link').addClass('swell-active');
            $('.swell-referral-holder .referral-content').addClass('swell-active');
            $('.referral-button-content .swell-referral-refer-show-link').removeClass('swell-active');
            $('.swell-referral-holder .swell-referral').removeClass('swell-active');
          }
        });
      },
      populateReferrals: function(){
        if (spapi.authenticated && spapi.activeReferralCampaign) {
          swellAPI.refreshCustomerDetails(function(){
            var referral_receipts = spapi.customer.referral_receipts;
            $('.table-data tr').remove();
            referral_receipts.forEach(function(referral_receipt) {
               var email = referral_receipt.email;
               var completed_at = referral_receipt.completed_at;
               if (completed_at) {
                  status = "completed";
               } else {
                  status = 'pending';
               }
               $(".table-data").append("<tr><td>" + email + "</td><td>" + status + "</td></tr>");
            });
          });
        }
      }
   };

}).call(this);


(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Redemption = {
    initializeRedemptions: function(conntainerSelector){
      var activator = "";
      if ($(conntainerSelector).hasClass("logged-in")) {
        activator = "";
      }
      spapi.activeRedemptionOptions.forEach(function(redemption){
        if(redemption.discount_type === "fixed_amount"){
          $(conntainerSelector).append('<li class="swell-redemption-option"> <div class="swell-redemption-option-content '+activator+'" data-redemption-option-id="'+ redemption.id +'"> <div class="swell-redemption-option-details"> <div class="swell-redemption-option-cost "> <div class="swell-header-details">'+(redemption.name.replace(" Off", ""))+'</div> </div> <div class="swell-redemption-option-value"> <div class="swell-details">'+redemption.cost_text+'</div> </div> </div> </div> </li>');
        }
      });
    }
  };

}).call(this);

// Tier_List Start
(function() {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Tier = {
    sortTiers:function(tiers){
      if(tiers[0].rank!= 0){
        while(tiers[0].rank!= 0){
          temp = tiers.pop();
          tiers.unshift(temp);
        }
      }
    },
    getTierById : function(id) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function(e) {
        return e.id === id;
      })[0];
    },
    getTierByRank: function(rank) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function(e) {
        return e.rank === rank;
      })[0];
    },
    getTierByClass: function(t_class) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function(e) {
        return e.class === t_class;
      })[0];
    },
    initializeDummyTier: function() {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      for (k = 0, len = tiers.length; k < len; k++) {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift({
        id: -1,
        rank: 0,
        dummy: true,
        name: "Members",
        points_multiplier:" 1",
        amount_spent_cents: 0,
        points_earned: 0,
      });
    },
    initializeCustomTierProperties: function() {
      var tiers = spapi.activeVipTiers;
        Tier_0 = SwellConfig.Tier.getTierByRank(0);
        Tier_1 = SwellConfig.Tier.getTierByRank(1);

      if(Tier_0){
        Tier_0.spend = "Entry conditions: Create an account <br>and sign up to our newsletter"; 
        Tier_0.point_multiplier = "1.0x multiplier"; 
        Tier_0.free_shipping = 'Free Shipping over $25+'; 
        Tier_0.excess_to_sales = ''; 
        Tier_0.merchandise_giveaway = ''; 
        Tier_0.exclusive_offers = '';  
        Tier_0.entry_gift = '';  
        Tier_0.class = 'tier_0'; 
      }
      if(Tier_1){
        Tier_1.spend = "Entry conditions: $"+(Tier_1.amount_spent_cents/100)+"+"; 
        Tier_1.point_multiplier = "2.0x multiplier"; 
        Tier_1.free_shipping = 'Free USPS Priority Mail'; 
        Tier_1.excess_to_sales = 'Early Access To Sales'; 
        Tier_1.merchandise_giveaway = 'Merchandise Giveaway'; 
        Tier_1.exclusive_offers = 'Exclusive Offers';  
        Tier_1.entry_gift = 'Tier entry reward - 25% off coupon';  
        Tier_1.class = 'tier_1';  
      }
    },
    initializeTiers: function(containerSelector) {
      var tiers;
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      tiers.forEach(function(tier) {
        return $(containerSelector).append('<li class="list-items '+ tier.class +'" data-tier-id="'+tier.id+'"> <div class="content-holder"> <div class="items-holder"> <div class="items-heading-holder"> <div class="swell-header-details">'+ tier.name +'</div> <div class="swell-details">'+ tier.spend +'</div> </div> <ul class="point-holder"> <li><span class="swell-details">'+ tier.point_multiplier +'</span></li> <li><span class="swell-details">'+ tier.free_shipping +'</span></li> <li><span class="swell-details">'+ tier.excess_to_sales +'</span></li> <li><span class="swell-details">'+ tier.merchandise_giveaway +'</span></li> <li><span class="swell-details">'+ tier.exclusive_offers +'</span></li> <li><span class="swell-details">'+ tier.entry_gift +'</span></li> </ul> </div> </div> </li>');
      });
    },
    setupStatus: function(containerSelector){
      if(spapi.authenticated){
        tiers = spapi.activeVipTiers;
        if(spapi.customer.vip_tier){
          current_tier = SwellConfig.Tier.getTierById(spapi.customer.vip_tier.id);
        }else{
           if(typeof(SwellConfig.Tier.getTierByRank(0).dummy) !== 'undefined' && SwellConfig.Tier.getTierByRank(0).dummy ){
            current_tier = SwellConfig.Tier.getTierByRank(0);
          }
        }
        $(containerSelector).addClass(current_tier.class);
        $(containerSelector).find('.list-items[data-tier-id="'+current_tier.id+'"]').prepend('<div class="current-tier">Current Status<span class="current-status-circle"></span></div>');  
        $(containerSelector).find('.list-items[data-tier-id="'+current_tier.id+'"]').addClass("swell-active");
        if(current_tier.rank < tiers.length-1){
          next_tier = SwellConfig.Tier.getTierByRank(current_tier.rank+1);
          encouragement = (spapi.customer.vip_tier_stats_needed.amount_cents_needed/100);
          $(containerSelector).find('.list-items[data-tier-id="'+next_tier.id+'"]').prepend('<div class="next-tier">Spend $'+encouragement+' more</div>');  
        }
      }else{
        $(containerSelector).addClass(SwellConfig.Tier.getTierByRank(0).class);
      }
    },
    applytierSlickSlider: function(containerSelector){
      $(containerSelector).slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToScroll:1,
        slidesToShow: 2,
        prevArrow: false,
        nextArrow: false,
        adaptiveHeight:false,
        responsive: [
        {
          breakpoint: 768,
          settings: {
            adaptiveHeight:true,
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
        ]
      });
    }
  };

}).call(this);
// Tier_List End

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.setupCartRedemptionPopup = {
    applyCartRedemptionOption: () => {
      $('body').on('click', '#swell-cart-apply-redemption', function(){
        $(".swell-custom-modal #swell-reward-heading").html("");
        $(".swell-custom-modal #swell-coupon-intro").html("");
        $(".swell-custom-modal #swell-reward-intro").html("");
        $(".swell-custom-modal #swell-coupon-code").html("");

        if(spapi.authenticated){
          redemptionOptionId =  $( "#swell-select-redemption-options option:selected" ).val();
          if( redemptionOptionId != 0){
            if(SwellConfig.setupCartRedemptionPopup.beforeDiscountRedemption())
            {
              $(document).on("swell:cart:updated", function()
              {
                if(window.location.href.indexOf("cart") > -1) {
                  window.location = "/cart";
                }
              });
              temp_holder = $(this);
              temp = $(this).html();
              $(this).html('<div class="swell-referral-loader"> <img src="//retail.socksmithcanada.ca/cdn/shop/t/14/assets/swell-loader.svg?v=92982006920604991191728495109"/> </div>');
              redemptionOption = swellAPI.findActiveRedemptionOptionById(redemptionOptionId);
              swellAPI.refreshCustomerDetails();
              if(redemptionOption.amount <= spapi.customer.adjusted_points_balance)
              {
                result = swellAPI.buyMultipleWithPoints([redemptionOption], function(){});
              }
              else
              {
                $(this).html(temp);
                $('.swell-custom-modal').css("display", "flex");
                $(".swell-custom-modal #swell-reward-heading").html('Not Enough Points');
                $("#swell-reward-intro").html('<span style="color: red;">Oops, you don\'t have enough points!</span>');
              }
            }
          }
        }
      });

      Swell.Cart.items.forEach(function(item) {
        if (item.properties._swell_discount_type == "cart_fixed_amount") {
          redeemedRedemptionOption = swellAPI.findActiveRedemptionOptionById(item.properties._swell_redemption_option_id);
          $(".m-cart_row-content .l-table").append('<div class="l-table_row"> <div class="l-table_cell m-cart_image"> </div> <div class="l-table_cell m-cart_meta"> <div class="list-view-item__title" style="padding: 20px 0;"> '+redeemedRedemptionOption.name+' </div> </div> <div class="l-table_cell l-text_center m-cart_price"> <span class="m-cart_row-priceVal">'+redeemedRedemptionOption.cost_text+'</span> </div> <div class="l-table_cell m-cart_quantity l-text_center"> <div class="cart__qty"> <label class="visually-hidden cart__qty-label">Quantity</label> <span class="m-input_number"> <span class="m-input_number-prev">-</span> <input style="background: #fff;" class="m-cart_quantity-input" type="number" value="1" min="0" disabled="true" pattern="[0-9]*"> <span class="m-input_number-next">+</span> </span> </div> </div> <div class="l-table_cell l-text_right m-cart_total"> <div> '+redeemedRedemptionOption.cost_text+' </div> <a href="javascript:void(0);" class="swell-remove-redeemedRedemptionOption m-cart_remove-item" data-redemption-id="'+redeemedRedemptionOption.id+'"></a> </div> </div>');
          return
        }
      });

      $('body').on('click',".swell-remove-redeemedRedemptionOption", function() {
        $(document).on("swell:cart:updated", function(){
          if(window.location.href.indexOf("cart") > -1) {
            window.location = "/cart";
          }
          else{
            $(temp_holder).html(temp);
            $('.swell-custom-modal').css("display", "flex");
            $(".swell-custom-modal #swell-reward-heading").html('Redeemed!');
            $("#swell-reward-intro").html('<span style="color: green;">You have redeemed the discount!</span>');
          }
        });
        $(".swell-remove-redeemedRedemptionOption").html('<div class="swell-custom-load-holder"><div class="lds-dual-ring"></div></div>');
        swellAPI.removeRedemptionOptionIdFromCart(redeemedRedemptionOption.id, function(){});
      });

      $("body").on('click', '.swell-custom-modal .close', function(e) {
        $('.swell-custom-modal').css("display", "none");
      });
    },
    beforeDiscountRedemption: function (){
      var redeemedItemsInCart = 0;
      var regularItemsInCart = 0;
      var discountInCart = 0;
      
      if(Swell.Cart && Swell.Cart.items){
        var cart = Swell.Cart;
        
        $.each(cart.items, function(index, item){
          if(item.properties._swell_points_used){
            redeemedItemsInCart++;
          } else if(item.line_price > 0){
            regularItemsInCart++; 
          }
        });
        
        Swell.Cart.items.forEach(function(item) {
          if (item.properties._swell_discount_type == "cart_fixed_amount") {
            discountInCart++;
          }
        });
        if(discountInCart > 0){
          $('.swell-custom-modal').css("display", "flex");
          $(".swell-custom-modal #swell-reward-heading").html('Oops!');
          $("#swell-reward-intro").html('<span style="color: red;">You already have a redeemed discount in your cart.</span>');
          return false;
        }
        else if(regularItemsInCart == 0){
          $('.swell-custom-modal').css("display", "flex");
          $(".swell-custom-modal #swell-reward-heading").html('Oops!');
          $("#swell-reward-intro").html('<span style="color: red;">You must add a priced item in your cart to redeem points for a discount.</span>');
          return false;
        }
        else{
          return true;
        }
      }
    },
    initializeRedemtionOptions : function(containerSelector){

      redemptionOptions = spapi.activeRedemptionOptions;
      redemptionOptions.forEach(function(redemption) {
        if(redemption.discount_type === 'cart_fixed_amount'){
          $(containerSelector).find('.swell-select-redemption-options').append('<option class="redemption-option" swell-redemption-name="'+redemption.name+'" value="'+redemption.id+'">'+redemption.name+' ('+redemption.cost_text+')</option>');
        }
      });
      $(containerSelector).css("display","flex");
      SwellConfig.setupCartRedemptionPopup.applyCartRedemptionOption();
    }
  };
}).call(this);
